<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Input from 'dashboard/components-next/input/Input.vue';
import Select from 'dashboard/components-next/select/Select.vue';
import { weekdayOptions } from '../helpers/whatsappRecontactTime';

defineProps({
  label: { type: String, required: true },
});

const weekday = defineModel('weekday', { type: String, required: true });
const time = defineModel('time', { type: String, default: '' });

const { t } = useI18n();
const weekdays = computed(() => weekdayOptions(t));
</script>

<template>
  <div class="flex flex-col gap-2">
    <p class="mb-0 text-sm font-medium text-n-slate-12">{{ label }}</p>
    <div class="flex flex-wrap items-end gap-3">
      <div class="flex flex-col gap-1">
        <span class="mb-0.5 text-heading-3 text-n-slate-12">
          {{ t('INBOX_MGMT.RECONTACT.FORM.DAY') }}
        </span>
        <Select
          v-model="weekday"
          accent="brand"
          :options="weekdays"
          :aria-label="t('INBOX_MGMT.RECONTACT.FORM.DAY')"
        />
      </div>
      <Input
        v-model="time"
        type="time"
        :label="t('INBOX_MGMT.RECONTACT.FORM.TIME')"
      />
    </div>
  </div>
</template>
